module.exports = __webpack_public_path__ + "img/wieza_galeria.a6580ed4.jpg";